export enum FORM_STATUS {
  REJECTED = 'REJECTED',
  PENDING = 'PENDING',
  FINISHED = 'FINISHED',
  INCOMPLETE = 'INCOMPLETE',
  ERROR = 'ERROR',
  WAITING = 'WAITING',
  NO_MODULATION = 'NO_MODULATION',
}
